import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./FullScreenLoader.css";
import loadingClip from "../assets/loading.webm";

const FullScreenLoader = () => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return ReactDOM.createPortal(
    <div className="fullscreen-loader">
      <video
        className="loader-video"
        src={loadingClip}
        autoPlay
        loop
        muted
        playsInline
      />
      <p>Please wait...</p>
    </div>,
    document.body
  );
};

export default FullScreenLoader;
